
import { Promise as BluebirdPromise } from 'bluebird'
import { Map } from 'immutable'
import { v4 as uuidv4 } from 'uuid'
import map from 'lodash/map'
import get from 'lodash/get'
import {
  REQUEST_ACCEPT_APPLICATION_JSON,
  RESPONSE_ERROR_TYPE_RANGE_400,
  TYPE_BROOKLYN,
  post as apiPost,
  get as apiGet,
  del as apiDel,
} from 'api-client'

export const COMMUNITY_PAGE_HERO_TEXT = `
  Thanks for participating in the Gaia Community Beta. 
  We're hard at work building an experience that allows our amazing community to connect and increase global consciousness more directly. 
  This is just the beginning and we look forward to your feedback! 
  Please understand that we are actively developing Community, and things may change, break, or otherwise not work as expected. 
  Please send any feedback to community@gaia.com
`

/**
 * Utility function to create dataURIs for image files
 * @param {File[]} files the files
 */
export async function createDataUri (file) {
  return new BluebirdPromise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)
    fileReader.onload = (fileEvent) => {
      const data = fileEvent.target.result
      const image = Map({
        filename: file.name,
        id: uuidv4(),
        data,
      })
      resolve(image)
      fileReader.onerror = (e) => {
        reject(e)
      }
    }
  })
}

/**
 * Utility function to shape file structure
 * @param {File[]} files the files
 */
export async function prepFiles (files) {
  return map(files, file => ({
    type: file.type,
    name: file.name,
    id: uuidv4(),
    file,
  }))
}

/**
 * Creates an activity
 * @param {Object} options the options
 * @param {Object} options.activity the activity as defined by ./activity
 */
export async function addActivity ({ auth, activity }) {
  const params = {
    responseErrorType: RESPONSE_ERROR_TYPE_RANGE_400,
    reqType: REQUEST_ACCEPT_APPLICATION_JSON,
    auth,
  }
  const response = await apiPost(
    '/v1/community/activity', activity, params, TYPE_BROOKLYN)
  return get(response, 'body', {})
}

/**
 * Removes an activity
 * @param {Object} options the options
 * @param {Object} options.activityId the activityId of activity to be removed
 */
export async function removeActivity ({ auth, activityId }) {
  const params = {
    reqType: REQUEST_ACCEPT_APPLICATION_JSON,
    auth,
  }
  const response = await apiDel(
    `/v1/community/activity/${activityId}`, {}, params, TYPE_BROOKLYN)
  return get(response, 'body', {})
}

/**
 * Creates a reaction
 * @param {Object} options the options
 * @param {Object} options.activity the activityUuid
 * @param {Object} options.type the type ie. LIKED
 */
export async function addReaction ({ auth, activity, type }) {
  const params = {
    reqType: REQUEST_ACCEPT_APPLICATION_JSON,
    auth,
  }
  const response = await apiPost(
    '/v1/community/reaction', { activity, type }, params, TYPE_BROOKLYN)
  return get(response, 'body', {})
}

/**
 * Removes a reaction
 * @param {Object} options the options
 * @param {Object} options.activityUuid the activityUuid of activity to be removed
 */
export async function removeReaction ({ auth, activityUuid }) {
  const params = {
    reqType: REQUEST_ACCEPT_APPLICATION_JSON,
    auth,
  }
  const response = await apiDel(
    `/v1/community/reaction/${activityUuid}`, {}, params, TYPE_BROOKLYN)
  return get(response, 'body', {})
}

/**
 * Connect feed
 * @param {Object} options the options
 * @param {Object} options.activity the activity as defined by ./activity
 */
export async function connectFeed ({ auth, id }) {
  const response = await apiGet(
    `/v1/community/feed/${id}/activities`,
    {},
    { auth },
    TYPE_BROOKLYN,
  )
  return get(response, 'body', {})
}

/**
 * Fetches activities
 * @param {Object} options the options
 * @param {Object} options.activity the activity as defined by ./activity
 */
export async function fetchActivities ({ auth }) { // id FIX THIS TO USE IDS
  const response = await apiGet(
    '/v1/community/feed/main/activities', // use id once the endpoint is fixed
    {},
    { auth },
    TYPE_BROOKLYN,
  )
  return get(response, 'body', {})
}
